import { updateUserApi } from '@/api-calls/user'
import { useAuth } from '@/auth/auth-context'
import { Button, Card, Input, Label } from '@blogging/ui'
import { useMutation, withQueryClientProvider } from '@ngtrvu/use-api'
import { useState } from 'react'
import { toast } from 'sonner'

function AccountSettingsPageContent() {
  const { user, checkAuth } = useAuth()
  const [name, setName] = useState(user?.name || '')

  const { mutate: updateUser, isPending } = useMutation(updateUserApi, {
    resourceName: 'update-user',
    onSuccess: () => {
      toast.success('Profile updated successfully')
      checkAuth()
    },
    onError: (error: any) => {
      toast.error(error?.message || 'Failed to update profile')
    },
  })

  const handleSave = () => {
    if (!name.trim()) {
      toast.error('Name cannot be empty')
      return
    }
    updateUser({ name: name.trim() })
  }

  const hasChanges = name !== (user?.name || '')

  return (
    <div className="max-w-xl">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold">Settings</h1>
        <p className="text-muted-foreground text-sm mt-1">
          Manage your account information.
        </p>
      </div>

      <div className="space-y-6">
        <Card className="p-5">
          <h2 className="font-medium mb-4">Profile</h2>
          <div className="space-y-4">
            <div className="flex items-center gap-4 pb-4 border-b">
              {user?.image ? (
                <img
                  src={user.image}
                  alt={user.name || 'Profile'}
                  className="h-12 w-12 rounded-full"
                />
              ) : (
                <div className="h-12 w-12 rounded-full bg-muted flex items-center justify-center text-muted-foreground">
                  {user?.name?.charAt(0) || user?.email?.charAt(0) || '?'}
                </div>
              )}
              <div>
                <p className="font-medium">{user?.name || 'User'}</p>
                <p className="text-sm text-muted-foreground">{user?.email}</p>
              </div>
            </div>

            <div className="space-y-2">
              <Label htmlFor="name">Display Name</Label>
              <Input
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Your name"
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                value={user?.email || ''}
                disabled
                className="bg-muted/50"
              />
              <p className="text-xs text-muted-foreground">
                Contact support to change your email.
              </p>
            </div>

            <div className="pt-2">
              <Button
                size="sm"
                onClick={handleSave}
                disabled={isPending || !hasChanges}
              >
                {isPending ? 'Saving...' : 'Save Changes'}
              </Button>
            </div>
          </div>
        </Card>
      </div>
    </div>
  )
}

export const AccountSettingsPage = withQueryClientProvider(
  AccountSettingsPageContent,
)
